<template>
  <v-card class="custom-card admin-card">
    <v-card-text class="pa-5">
      <div class="d-flex align-start gap-4">
        <v-avatar :color="avatarColor" size="56">
          {{ initials }}
        </v-avatar>
        <div class="flex-grow-1">
          <p class="text-semibold text-h6">{{ name }}</p>
          <p class="text-muted text-sm mb-2">{{ email }}</p>
          <div class="d-flex gap-2 align-center">
            <v-chip size="small" variant="tonal" color="primary">
              {{ role }}
            </v-chip>
            <v-chip size="small" variant="tonal" :color="statusColor">
              {{ status }}
            </v-chip>
          </div>
        </div>
      </div>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="justify-space-between">
      <v-btn variant="text" color="primary" size="small" prepend-icon="mdi-pencil">
        Edit
      </v-btn>
      <v-btn variant="text" color="error" size="small" prepend-icon="mdi-delete">
        Delete
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'AdminCard',
  props: {
    name: {
      type: String,
      required: true
    },
    email: {
      type: String,
      required: true
    },
    role: {
      type: String,
      default: 'Moderator'
    },
    status: {
      type: String,
      default: 'Active',
      validator: (value) => ['Active', 'Inactive'].includes(value)
    }
  },
  computed: {
    initials() {
      return this.name
        .split(' ')
        .map((n) => n.charAt(0))
        .join('')
        .toUpperCase()
    },
    avatarColor() {
      const colors = ['#667eea', '#764ba2', '#f093fb', '#f5576c', '#4facfe']
      let hash = 0
      for (let i = 0; i < this.name.length; i++) {
        hash = this.name.charCodeAt(i) + ((hash << 5) - hash)
      }
      return colors[Math.abs(hash) % colors.length]
    },
    statusColor() {
      return this.status === 'Active' ? 'success' : 'error'
    }
  }
}
</script>

<style scoped>
.admin-card {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  height: 100%;
}

.admin-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.12) !important;
}

.text-semibold {
  font-weight: 600;
}

.text-muted {
  color: #888888;
}

.text-sm {
  font-size: 0.9rem;
}

.gap-4 {
  gap: 16px;
}

.gap-2 {
  gap: 8px;
}
</style>
